import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = { class: "max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = {
  href: "/conversations",
  class: "text-sm text-blue-700 hover:text-blue-900 mb-4 inline-block"
}
const _hoisted_4 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-6 flex items-center gap-3" }
const _hoisted_5 = { class: "inline-flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 text-sm font-medium text-blue-800 shrink-0" }
const _hoisted_6 = { class: "text-lg font-semibold text-gray-900" }
const _hoisted_7 = {
  ref: "messagesContainer",
  class: "space-y-3 mb-6 max-h-[60vh] overflow-y-auto px-1"
}
const _hoisted_8 = {
  key: 0,
  class: "text-center text-gray-400 text-sm py-8"
}
const _hoisted_9 = { class: "text-sm whitespace-pre-line" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-4" }
const _hoisted_12 = { class: "flex gap-2 items-center" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "relative" }
const _hoisted_15 = {
  key: 0,
  class: "absolute bottom-full right-0 mb-1 bg-white border border-gray-200 rounded-lg shadow-lg p-2 z-50 w-64 flex flex-wrap gap-1"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "messages"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, "← " + _toDisplayString($setup.t('messages.back_to_inbox')), 1 /* TEXT */),
      _createCommentVNode(" Header "),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString($props.otherUser?.name?.charAt(0)?.toUpperCase() || '?'), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_6, _toDisplayString($props.otherUser?.name || $setup.t('messages.unknown_user')), 1 /* TEXT */)
      ]),
      _createCommentVNode(" Messages "),
      _createElementVNode("div", _hoisted_7, [
        ($setup.msgs.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($setup.t('messages.no_messages')), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.msgs, (msg) => {
          return (_openBlock(), _createElementBlock("div", {
            key: msg.id,
            class: _normalizeClass(['flex', msg.user.id === $props.userId ? 'justify-end' : 'justify-start'])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(['max-w-[75%] rounded-xl px-4 py-2 relative group',
                        msg.user.id === $props.userId ? 'bg-blue-600 text-white' : 'bg-white border border-gray-200 text-gray-900'])
            }, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(msg.body), 1 /* TEXT */),
              _createElementVNode("div", {
                class: _normalizeClass(['flex items-center gap-2 mt-1', msg.user.id === $props.userId ? 'justify-end' : 'justify-start'])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(['text-xs', msg.user.id === $props.userId ? 'text-blue-200' : 'text-gray-400'])
                }, _toDisplayString($setup.formatTime(msg.created_at)), 3 /* TEXT, CLASS */),
                (msg.user.id === $props.userId)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: $event => ($setup.deleteMessage(msg)),
                      class: _normalizeClass(['text-xs opacity-0 group-hover:opacity-100 transition', msg.user.id === $props.userId ? 'text-blue-200 hover:text-white' : 'text-red-400 hover:text-red-600'])
                    }, _toDisplayString($setup.t('messages.delete')), 11 /* TEXT, CLASS, PROPS */, _hoisted_10))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */)
            ], 2 /* CLASS */)
          ], 2 /* CLASS */))
        }), 128 /* KEYED_FRAGMENT */))
      ], 512 /* NEED_PATCH */),
      _createCommentVNode(" Input "),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("form", {
          onSubmit: _withModifiers($setup.sendMessage, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              ref: "messageInput",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.newMessage) = $event)),
              type: "text",
              placeholder: $setup.t('messages.placeholder'),
              required: "",
              class: "flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, null, 8 /* PROPS */, _hoisted_13), [
              [_vModelText, $setup.newMessage]
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = $event => ($setup.showEmojis = !$setup.showEmojis)),
                class: "text-gray-400 hover:text-gray-600 text-xl p-1"
              }, "😊"),
              ($setup.showEmojis)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.emojis, (e) => {
                      return _createElementVNode("button", {
                        key: e,
                        type: "button",
                        onClick: $event => ($setup.addEmoji(e)),
                        class: "text-xl hover:bg-gray-100 rounded p-1 cursor-pointer"
                      }, _toDisplayString(e), 9 /* TEXT, PROPS */, _hoisted_16)
                    }), 64 /* STABLE_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("button", {
              type: "submit",
              disabled: !$setup.newMessage.trim(),
              class: "px-4 py-2 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition disabled:opacity-50"
            }, _toDisplayString($setup.t('messages.send')), 9 /* TEXT, PROPS */, _hoisted_17)
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ])
  ]))
}